export const serviceProviders = '/service-providers';
export const serviceProvider = (id: number) => `/service-providers/${id}`;
export const download = 'service-providers/download';
